import { render, staticRenderFns } from "./LeaderboardGrid.vue?vue&type=template&id=69d33713&"
import script from "./LeaderboardGrid.vue?vue&type=script&lang=js&"
export * from "./LeaderboardGrid.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports